import { useEffect } from "react";

interface BulkEditNavigationGuardProps {
  hasUnsavedChanges: boolean;
}

/**
 * Handles browser-level navigation guard (beforeunload).
 * For in-app navigation, the "Return to Projects" button in BulkEditPage
 * shows a confirmation modal before navigating.
 */
export default function BulkEditNavigationGuard({ hasUnsavedChanges }: BulkEditNavigationGuardProps) {
  useEffect(() => {
    if (!hasUnsavedChanges) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  return null;
}
